import { useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import "./ExpandableItem.css"; 

interface ExpandableItemProps {
  title: string;
  content: string;
  borderColor?: string;
}

export default function ExpandableItem({ title, content, borderColor = "gray" }: ExpandableItemProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="expandable-item" style={{ borderBottom: `2px solid ${borderColor}` }} onClick={() => setIsOpen(!isOpen)}>
      <div className="expandable-header">
        <h3 className="expandable-title">{title}</h3>
        <motion.div
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3 }}
          className={`chevron-icon ${isOpen ? "open" : ""}`}
        >
          <ChevronDown />
        </motion.div>
      </div>
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0 }}
        transition={{ duration: 0.3 }}
        className="expandable-content"
      >
        <p>{content}</p>
      </motion.div>
    </div>
  );
}
